// Product Gallery Mobile JavaScript

document.addEventListener('DOMContentLoaded', initProductGalleryMobile);
document.addEventListener('variant:change', handleVariantChange);

/**
 * Initialize the mobile product gallery
 */
// Track touch events for flick scrolling
let touchStartX = 0;
let touchEndX = 0;
let touchStartTime = 0;

function initProductGalleryMobile() {
  const galleries = document.querySelectorAll('.product-gallery-mobile');

  galleries.forEach(gallery => {
    const carousel = gallery.querySelector('scroll-carousel');
    const slides = carousel?.querySelector('.product-gallery-mobile__slides');
    const thumbs = gallery.querySelectorAll('.product-gallery-mobile__thumbnail-btn');
    const nav = gallery.querySelector('.product-gallery-mobile__nav');
    const navIndicator = gallery.querySelector('.product-gallery-mobile__nav-indicator');

    if (!carousel || !slides || thumbs.length === 0) return;

    // Set up the navigation indicator
    updateNavIndicator(slides, navIndicator, thumbs.length);

    // Add scroll event listener to update active thumbnail and nav indicator
    slides.addEventListener('scroll', () => {
      updateActiveThumbnail(gallery);
      updateNavIndicator(slides, navIndicator, thumbs.length);
    });

    // Add touch event listeners for flick scrolling
    slides.addEventListener('touchstart', (e) => {
      handleTouchStart(e);
      // Show navigation on touch start
      if (nav) {
        nav.classList.add('is-visible');
        clearTimeout(nav.fadeTimeout);
      }
    }, { passive: true });

    slides.addEventListener('touchend', (e) => {
      handleTouchEnd(e, gallery);
      // Hide navigation after touch end with a delay
      if (nav) {
        clearTimeout(nav.fadeTimeout);
        nav.fadeTimeout = setTimeout(() => {
          nav.classList.remove('is-visible');
        }, 2000); // Hide after 2 seconds
      }
    }, { passive: true });

    // Add click event listeners to thumbnails
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const targetId = thumb.getAttribute('data-target-slide');

        // Update active state on thumbnails
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');

        scrollToSlide(gallery, targetId);
      });
    });

    // Initial update of active thumbnail
    updateActiveThumbnail(gallery);
  });
}

/**
 * Update the navigation indicator based on scroll position
 */
function updateNavIndicator(slides, indicator, totalSlides) {
  if (!slides || !indicator || totalSlides <= 0) return;

  const scrollPosition = slides.scrollLeft;
  const maxScroll = slides.scrollWidth - slides.clientWidth;

  // Calculate the indicator width as a percentage of the total width
  const indicatorWidth = (slides.clientWidth / slides.scrollWidth) * 100;

  // Calculate the indicator position as a percentage of the scrollable area
  const scrollPercentage = maxScroll > 0 ? (scrollPosition / maxScroll) * (100 - indicatorWidth) : 0;

  // Update the indicator style
  indicator.style.width = `${indicatorWidth}%`;
  indicator.style.transform = `translateX(${scrollPercentage}%)`;
}

// Handle touch start event
function handleTouchStart(e) {
  touchStartX = e.changedTouches[0].screenX;
  touchStartTime = Date.now();
}

// Handle touch end event
function handleTouchEnd(e, gallery) {
  touchEndX = e.changedTouches[0].screenX;
  const touchEndTime = Date.now();

  // Calculate flick velocity
  const touchDuration = touchEndTime - touchStartTime;
  const touchDistance = touchStartX - touchEndX;
  const velocity = Math.abs(touchDistance) / touchDuration;

  // If it's a fast flick, scroll multiple slides
  if (velocity > 0.5 && Math.abs(touchDistance) > 50) {
    const slides = gallery.querySelector('.product-gallery-mobile__slides');
    const slideElements = slides.querySelectorAll('.product-gallery-mobile__slide');

    if (slideElements.length === 0) return;

    // Calculate current slide index
    const slideWidth = slideElements[0].offsetWidth;
    const gap = 5; // 5px gap between slides
    const totalItemWidth = slideWidth + gap;
    const currentIndex = Math.round(slides.scrollLeft / totalItemWidth);

    // Calculate target index based on flick direction and velocity
    let targetIndex = currentIndex;
    const slidesToMove = Math.min(Math.floor(velocity * 2), 3); // Max 3 slides at once

    if (touchDistance > 0) { // Flick left (next)
      targetIndex = Math.min(currentIndex + slidesToMove, slideElements.length - 1);
    } else { // Flick right (previous)
      targetIndex = Math.max(currentIndex - slidesToMove, 0);
    }

    // Scroll to the target slide
    const scrollPosition = targetIndex * totalItemWidth;
    smoothScrollTo(slides, scrollPosition, 300);
  }

  // Update active thumbnail
  updateActiveThumbnail(gallery);
}

/**
 * Update the active thumbnail based on the current scroll position
 */
function updateActiveThumbnail(gallery) {
  const slides = gallery.querySelector('.product-gallery-mobile__slides');
  const thumbs = gallery.querySelectorAll('.product-gallery-mobile__thumbnail-btn');
  const thumbnailsContainer = gallery.querySelector('.product-gallery-mobile__thumbnails');

  if (!slides || !thumbs.length) return;

  // Get all slides
  const slideElements = slides.querySelectorAll('.product-gallery-mobile__slide');
  if (slideElements.length === 0) return;

  // Calculate which slide is most visible
  const scrollPosition = slides.scrollLeft;
  const slideWidth = slideElements[0].offsetWidth;
  const gap = 5; // 5px gap between slides
  const viewportWidth = slides.clientWidth;

  // Find the slide that is most visible in the viewport
  let mostVisibleSlideIndex = 0;
  let maxVisibleWidth = 0;

  slideElements.forEach((_, index) => {
    const slideLeft = index * (slideWidth + gap);
    const slideRight = slideLeft + slideWidth;

    const visibleLeft = Math.max(slideLeft, scrollPosition);
    const visibleRight = Math.min(slideRight, scrollPosition + viewportWidth);
    const visibleWidth = Math.max(0, visibleRight - visibleLeft);

    if (visibleWidth > maxVisibleWidth) {
      maxVisibleWidth = visibleWidth;
      mostVisibleSlideIndex = index;
    }
  });

  // Find the active slide
  if (slideElements[mostVisibleSlideIndex]) {
    const activeSlideId = slideElements[mostVisibleSlideIndex].getAttribute('data-media-id');
    let activeThumb = null;

    // Update thumbnail active states
    thumbs.forEach(thumb => {
      const thumbTargetId = thumb.getAttribute('data-target-slide');

      if (thumbTargetId === activeSlideId) {
        thumb.classList.add('is-active');
        activeThumb = thumb;
      } else {
        thumb.classList.remove('is-active');
      }
    });

    // Ensure the active thumbnail is visible
    if (activeThumb && thumbnailsContainer) {
      ensureThumbnailVisible(activeThumb, thumbnailsContainer);
    }
  }
}

/**
 * Scroll to a specific slide by ID
 */
function scrollToSlide(gallery, slideId) {
  const slides = gallery.querySelector('.product-gallery-mobile__slides');

  // Convert slideId to string to ensure consistent comparison
  const mediaIdString = String(slideId);

  // Try to find the target slide by data-media-id attribute
  let targetSlide = gallery.querySelector(`.product-gallery-mobile__slide[data-media-id="${mediaIdString}"]`);

  // If not found, try without quotes (in case it's stored as a number)
  if (!targetSlide) {
    const allSlides = gallery.querySelectorAll('.product-gallery-mobile__slide');
    for (const slide of allSlides) {
      const slideMediaId = slide.getAttribute('data-media-id');
      if (slideMediaId && Number(slideMediaId) === Number(slideId)) {
        targetSlide = slide;
        break;
      }
    }
  }

  const nav = gallery.querySelector('.product-gallery-mobile__nav');
  const navIndicator = gallery.querySelector('.product-gallery-mobile__nav-indicator');

  if (!slides || !targetSlide) {
    console.error('Could not find target slide or slides container');
    return;
  } 

  // Get all slides
  const slideElements = slides.querySelectorAll('.product-gallery-mobile__slide');

  // Find the index of the target slide
  const targetIndex = Array.from(slideElements).indexOf(targetSlide);

  // Calculate the scroll position
  const slideWidth = slideElements[0].offsetWidth;
  const gap = 5; // 5px gap between slides
  const scrollPosition = targetIndex * (slideWidth + gap);

  // Show navigation indicator
  if (nav) {
    nav.classList.add('is-visible');
    clearTimeout(nav.fadeTimeout);
    nav.fadeTimeout = setTimeout(() => {
      nav.classList.remove('is-visible');
    }, 2000); // Hide after 2 seconds
  }

  // Update navigation indicator
  if (navIndicator) {
    updateNavIndicator(slides, navIndicator, slideElements.length);
  }

  // Update active thumbnail
  updateActiveThumbnail(gallery);

  // Also update thumbnail active states directly
  const thumbs = gallery.querySelectorAll('.product-gallery-mobile__thumbnail-btn');
  thumbs.forEach(thumb => {
    const thumbTargetId = thumb.getAttribute('data-target-slide');
    if (String(thumbTargetId) === String(slideId)) {
      thumb.classList.add('is-active');
    } else {
      thumb.classList.remove('is-active');
    }
  });

  // Scroll to the target slide with a custom smooth scroll
  smoothScrollTo(slides, scrollPosition, 300);

  // Also update the active class on slides
  slideElements.forEach((slide, index) => {
    if (index === targetIndex) {
      slide.classList.add('is-active');
    } else {
      slide.classList.remove('is-active');
    }
  });
}

/**
 * Ensure the active thumbnail is visible in the thumbnails container
 */
function ensureThumbnailVisible(thumbnail, container) {
  if (!thumbnail || !container) return;

  const thumbnailRect = thumbnail.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  // If thumbnail is not fully visible, scroll the container
  if (thumbnailRect.left < containerRect.left) {
    container.scrollLeft -= (containerRect.left - thumbnailRect.left + 10);
  } else if (thumbnailRect.right > containerRect.right) {
    container.scrollLeft += (thumbnailRect.right - containerRect.right + 10);
  }
}

/**
 * Smooth scroll function with easing
 */
function smoothScrollTo(element, to, duration) {
  if (!element) return;

  const start = element.scrollLeft;
  const change = to - start;
  const startTime = performance.now();

  function animateScroll(currentTime) {
    const elapsedTime = currentTime - startTime;

    if (elapsedTime > duration) {
      element.scrollLeft = to;
      return;
    }

    // Easing function: easeOutQuad for smooth scrolling
    const progress = elapsedTime / duration;
    const easeProgress = -progress * (progress - 2);

    element.scrollLeft = start + change * easeProgress;
    requestAnimationFrame(animateScroll);
  }

  requestAnimationFrame(animateScroll);
}

/**
 * Handle variant change events
 */
function handleVariantChange(event) {
  if (event.detail && event.detail.variant && event.detail.variant.featured_media) {
    const mediaId = event.detail.variant.featured_media.id;
    const galleries = document.querySelectorAll('.product-gallery-mobile');

    galleries.forEach(gallery => {
      // Debug: Log all available slides and their media IDs
      const allSlides = gallery.querySelectorAll('.product-gallery-mobile__slide');
      scrollToSlide(gallery, mediaId);
    });
  } else {
    console.error('Variant change event received but no featured media found:', event.detail);
  }
}
